var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRankingArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64583 5.45833C4.53472 5.45833 4.43056 5.44097 4.33333 5.40625C4.23611 5.37153 4.14583 5.3125 4.0625 5.22917L0.229167 1.39583C0.0763889 1.24306 0 1.04861 0 0.8125C0 0.576389 0.0763889 0.381944 0.229167 0.229167C0.381944 0.0763889 0.576389 0 0.8125 0C1.04861 0 1.24306 0.0763889 1.39583 0.229167L4.64583 3.47917L7.89583 0.229167C8.04861 0.0763889 8.24306 0 8.47917 0C8.71528 0 8.90972 0.0763889 9.0625 0.229167C9.21528 0.381944 9.29167 0.576389 9.29167 0.8125C9.29167 1.04861 9.21528 1.24306 9.0625 1.39583L5.22917 5.22917C5.14583 5.3125 5.05556 5.37153 4.95833 5.40625C4.86111 5.44097 4.75694 5.45833 4.64583 5.45833Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRankingArrowDown);
export default __webpack_public_path__ + "static/media/icon_ranking_arrow_down.982c5fd141cc97dee77622d7a33fbf9e.svg";
export { ForwardRef as ReactComponent };